export default function isValidLicenseCount(count: string): boolean {
  return parseInt(count, 10) > 0;
}
